import { httpClient } from '../httpClient';

export const auditApi = {
  getLogs: (params) =>
    httpClient.get('/audit/', { params }),

  getSummary: (days = 30) =>
    httpClient.get('/audit/summary', { params: { days } }),

  getActions: () =>
    httpClient.get('/audit/actions'),

  getEntityTypes: () =>
    httpClient.get('/audit/entity-types'),

  exportCsv: (params) =>
    httpClient.get('/audit/export', { params, responseType: 'blob' }),

  // SDAIA Export
  sdaiaExport: (params) =>
    httpClient.post('/audit/sdaia-export', params, { timeout: 60000 }),

  sdaiaExportDownload: (params) =>
    httpClient.post('/audit/sdaia-export', params, { responseType: 'blob', timeout: 60000 }),

  // Backend returns a JSON status body while processing but the raw zip
  // blob once completed — fetch as blob and branch on Blob.type in the caller.
  getSdaiaExportStatus: (taskId) =>
    httpClient.get(`/audit/sdaia-export/${taskId}`, { responseType: 'blob' }),

  // Integrity Verification
  verifyIntegrity: (params = {}) =>
    httpClient.post('/audit/verify-integrity', params),

  // Disposal Records
  getDisposalRecords: (params) =>
    httpClient.get('/audit/disposal-records', { params }),

  verifyDisposal: (id, params) =>
    httpClient.post(`/audit/disposal-records/${id}/verify`, params),

  getDisposalCertificate: (id) =>
    httpClient.get(`/audit/disposal-records/${id}/certificate`),

  // Dashboard Summary
  getDashboardSummary: () =>
    httpClient.get('/audit/dashboard-summary'),

  // DPO-relevant view (PDPL Art. 31 oversight scope)
  getDpoView: (params) =>
    httpClient.get('/audit/dpo-view', { params }),

  getUnifiedFeed: (params) =>
    httpClient.get('/audit/unified-feed', { params }),
};
